import styled from 'styled-components';
import Sidebar from '~components/Sidebar';
import { media } from '~constants/media';
import { CloseO } from 'styled-icons/evil/CloseO';

export const StyledSidebar = styled(Sidebar)<any>`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 25px 25px;
  background-color: #6082ff;

  ${media.md`
    width: 50%;
  `}

  ${media.xl`
    padding: 45px 100px;
    width: 640px;
    max-width: 50%;
  `}
`;

export const IconWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const CloseIcon = styled(CloseO)`
  width: 40px;
  height: 40px;
  fill: white;
  cursor: pointer;

  &:hover {
    opacity: 0.6;
  }

  ${media.md`
     width: 50px;
     height: 50px;
  `}

  ${media.xl`
     width: 70px;
     height: 70px;
  `}
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-grow: 1;
`;
